<script lang="ts">
import VInput             from '@/lib/components/VInput/VInput.vue';
import VInputAutocomplete from '@/lib/components/VInputAutocomplete/VInputAutocomplete.vue';
import VInputNumberRus    from "@/lib/components/VInputNumberRus/VInputNumberRus.vue";
import VTextarea          from "@/lib/components/VTextarea/VTextarea.vue";

export default defineComponent({
	name: "InputsSample",

	components: {
		VInput,
		VInputAutocomplete,
		VInputNumberRus,
		VTextarea,
	},

	data() {
		return {
			visible: false,
			emptyModel: null,
			emptyModel3: null,
			options2: new Array(50).fill(null).map((val, ind) => {
				return `Test variant ${ind}`;
			}),
			values: {
				options: null,
				searchFn: null,
				dataUrl: null
			},
			textarea: null,
		}
	}
});
</script>

<template>
	<article>
		<h2>VInput</h2>
		<VInput v-model="emptyModel" label="Высота диалога" label-width="150px" />
		<pre>v-model {{ emptyModel }}</pre>
	</article>
	<br>
	<hr>
	<br>
	<article>
		<h2>VInputAutocomplete</h2>
		<VInputAutocomplete
			v-model="values.options"
			:options="options2"
			placeholder="Синхронный поиск по массиву"
		/>
	</article>
	<br>
	<hr>
	<br>
	<article>
		<h2>VInputNumberRus: {{ emptyModel3 }}</h2>
		<VInputNumberRus v-model="emptyModel3"/>
		<pre>v-model {{ emptyModel3 }}</pre>
	</article>
	<br>
	<hr>
	<br>
	<article>
		<h2>VTextarea</h2>
		<VTextarea v-model="textarea"/>
		<pre>v-model {{ textarea }}</pre>
	</article>

	<article>
		<h2>VInputNumberRusNew</h2>
		<VInputNumberRus
			required
			:precision="3"
			v-model="emptyModel3"
		/>
<pre>
{{ emptyModel3 }}
</pre>
	</article>
</template>

